import { useCallback } from 'react';
import { TimesheetReportsApi } from 'api/timesheets/reports/api';
import {
  CategoryParam,
  ProjectParam,
  UserParam,
} from 'api/timesheets/reports/types';
import {
  DateRange,
  getFormattedValueFromDateRange,
} from 'components/organisms/projects-report/common/range-picker/types';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { FieldFilter } from 'components/organisms/tasks/filters';

interface Props {
  range: DateRange;
  filters?: FieldFilter[];
  match?: QueryCombinerType;
  param?: ProjectParam | UserParam | CategoryParam;
}
export const useExport = ({
  range,
  param,
  filters = [],
  match = QueryCombinerType.Any,
}: Props) => {
  const exportAsCSV = useCallback(() => {
    const [startDate, endDate] = getFormattedValueFromDateRange(range);

    TimesheetReportsApi.exportAsCSV(
      startDate,
      endDate,
      filters,
      match,
      param,
    ).then((downloadUrl) => {
      window.open(downloadUrl, '_blank');
    });
  }, [range, param, filters, match]);

  return {
    exportAsCSV,
  };
};
